export default "__VITE_ASSET__BU06Uali__"